﻿import * as React from "react";
import { Icon } from "../Components";
import MuiTextField from "@material-ui/core/TextField";

export interface ISearchFieldProps {
    /* Optional: A CSS class to add to the loading container */
    className?: string;

    /* Fires on change of the input */
    onChange: (
        ev: React.ChangeEvent<
            HTMLTextAreaElement | HTMLInputElement | HTMLSelectElement
        >,
    ) => void;

    /* Clears the current search */
    onClearSearch: () => void;

    /* The current value in the search */
    value: string;

    /* Automatically focuses this text input on first mount if 'true' */
    autoFocus?: boolean;
}

export const SearchField: React.FunctionComponent<ISearchFieldProps> = (
    props,
): React.ReactElement => (
    <div
        className={`releasenotes-search ${
            props.className ? props.className : ``
        }`}
    >
        <div className={`releasenotes-textfield-container`}>
            <MuiTextField
                autoFocus={props.autoFocus}
                className={`releasenotes-textfield`}
                InputProps={{
                    disableUnderline: true,
                    style: {
                        height: `22px`,
                    },
                }}
                onChange={props.onChange}
                placeholder={`Search`}
                value={props.value}
            />
        </div>
        <Icon
            className={`search-icon`}
            url={`${ROOT_IMAGES_URL}/UI/search.svg`}
        />
        {props.value.length > 0 && (
            <div
                className={`clear-search-icon`}
                onClick={(): void => props.onClearSearch()}
            >
                &times;
            </div>
        )}
    </div>
);
